import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./auth.component').then(m => m.AuthComponent),
    children: [
      {
        path: 'change-email',
        loadComponent: () => import('./components/change-email/change-email.component').then(m => m.ChangeEmailComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./components/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./components/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      },
      {
        path: 'sign-in',
        loadComponent: () => import('./components/sign-in/sign-in.component').then(m => m.SignInComponent),
        data: { returnUrl: window.location.pathname }
      },
      {
        path: 'sign-up',
        loadComponent: () => import('./components/sign-up/sign-up.component').then(m => m.SignUpComponent)
      },
      {
        path: 'sign-in-token',
        loadComponent: () => import('./components/sign-in-token/sign-in-token.component').then(m => m.SignInTokenComponent)
      },
      { path: 'login', redirectTo: 'sign-in', pathMatch: 'full' },
      { path: 'signin', redirectTo: 'sign-in', pathMatch: 'full' },
      { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
      { path: '**', redirectTo: 'sign-in', pathMatch: 'full' }
    ]
  }
];
